import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

/**
 * DS Search input — icon + text input.
 * Enter 키 입력 시 onSubmit 호출.
 *
 * @param {object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {() => void} [props.onSubmit]
 * @param {string} [props.placeholder]
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 */
const DSSearchInput = ({
  value,
  onChange,
  onSubmit,
  placeholder = "검색어 입력",
  className = "",
  style,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) {
      onSubmit();
    }
  };

  return (
    <div className={`ds-search ${className}`} style={style}>
      <FontAwesomeIcon icon={faMagnifyingGlass} className="ds-search__icon" />
      <input
        className="ds-search__input"
        type="text"
        value={value ?? ""}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default React.memo(DSSearchInput);
